import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateOrganizationMutationVariables = Types.Exact<{
  input: Types.CreateOrganizationInput
}>

export type CreateOrganizationMutation = {
  __typename?: 'Mutation'
  createOrganization?: {
    __typename?: 'CreateOrganizationPayload'
    orgId?: number | null
    access?: { __typename?: 'FeatureAccess'; orgAdminDashboard: Types.AccessRequirementEnum } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateOrganizationDocument = `
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    orgId
    access {
      orgAdminDashboard
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCreateOrganizationMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CreateOrganizationMutation,
    TError,
    CreateOrganizationMutationVariables,
    TContext
  >
) =>
  useMutation<CreateOrganizationMutation, TError, CreateOrganizationMutationVariables, TContext>(
    ['CreateOrganization'],
    (variables?: CreateOrganizationMutationVariables) =>
      fetchGql<CreateOrganizationMutation, CreateOrganizationMutationVariables>(
        CreateOrganizationDocument,
        variables
      )(),
    options
  )
